import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Message } from 'src/app/interfaces/message.model';
import { Observable, Subject } from 'rxjs';
import { Subscription } from 'rxjs';
import { filter,map } from 'rxjs/operators';
import { UsersService } from './users.service';
import { MatSnackBar } from '@angular/material/snack-bar';



@Injectable({
  providedIn: 'root'
})
export class BroadcastService {

  constructor(
    private userService: UsersService,
    private router: Router,
    private snackbar:MatSnackBar,
  ) { }
  //private _handler: Subject<Message> = new Subject<Message>();

  private eventBrocker = new Subject<Message>();

  on(eventType: Message): Observable<Message> {
    return this.eventBrocker.pipe(filter(message => message.type === eventType.type));
  }

  dispatch<T>(event: Message): void {
    this.eventBrocker.next(event);
  }

  sessionCheck(error){
    //console.log('sessionCheck')
    if(error.server_error_code === 'sessionExpired'){
      this.snackbar.open('Session Expired, Please Login and Try again','',{
        duration:3500
      })

     this.userService.removeUserLocalStorage();
     this.router.navigate(['/']);
      
    }else{
      let message = error && error.server_error_messsage;
      if(typeof message !== 'string' || message.trim() === ''){
        message = 'Something went wrong, please try again';
      }
      this.snackbar.open(message,'',{
        duration:3000
      })
    }
  }


  // boradcast(type: string, payload: any = null) {
  //   this._handler.next({ type, payload });
  // }

  // subscribe(type: string, callback: (payload: any) => void): 
  // Subscription {
  //   //TODO filter is not loding
  //   return this._handler
  //     .filter(message => message.type === type)
  //     .map(message => message.payload)
  //     .subscribe(callback);
  // }
}
